import React, { useState, useEffect } from 'react';
import { getCurrentRace, getRaces } from '../api';

function formatTimeLeft(diff) {
    if (diff <= 0) return null;

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    const pad = (n) => String(n).padStart(2, '0');

    const parts = [];
    if (days > 0) parts.push({ value: days, label: 'd' });
    parts.push({ value: pad(hours), label: 'h' });
    parts.push({ value: pad(minutes), label: 'm' });
    parts.push({ value: pad(seconds), label: 's' });

    return parts;
}

export default function RaceCountdown() {
    const [race, setRace] = useState(null);
    const [timeLeft, setTimeLeft] = useState('');

    useEffect(() => {
        let mounted = true;

        async function load() {
            try {
                const currentId = await getCurrentRace();
                if (!currentId || !mounted) return;

                const races = await getRaces();
                if (!mounted) return;

                const current = races.find((r) => String(r.id) === String(currentId));
                if (current && current.start_time) {
                    setRace(current);
                }
            } catch (e) {
                console.error('RaceCountdown load error', e);
            }
        }

        load();
        return () => { mounted = false; };
    }, []);

    useEffect(() => {
        if (!race || !race.start_time) return;

        function tick() {
            const pickLockTime = race.pick_lock_time
                ? new Date(race.pick_lock_time).getTime()
                : new Date(race.start_time).getTime() + (4 * 60 * 1000);
            const diff = pickLockTime - Date.now();
            const parts = formatTimeLeft(diff);
            setTimeLeft(parts);
        }

        tick();
        const interval = setInterval(tick, 1000);
        return () => clearInterval(interval);
    }, [race]);

    if (!race) return null;

    const raceName = (race.name || '').replace(/Grand Prix/gi, 'GP');

    return (
        <div className="race-countdown d-flex align-items-center text-white ms-3">
            <div className="d-flex flex-column align-items-start lh-1">
                <span className="small fw-semibold mb-1">{raceName} picks lock in</span>
                <div className="d-flex gap-1">
                    {timeLeft ? (
                        timeLeft.map((p, i) => (
                            <span key={i} className="race-countdown-box">
                                {p.value}<span className="race-countdown-label">{p.label}</span>
                            </span>
                        ))
                    ) : (
                        <span className="race-countdown-box race-countdown-box--ended">Race started</span>
                    )}
                </div>
            </div>
        </div>
    );
}
